import {
  getPostApiV1ThreeLetterCodeClientAdminsUsersMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsUsersMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  PostApiV1ThreeLetterCodeClientAdminsUsers201,
  PostApiV1ThreeLetterCodeClientAdminsUsersBody,
} from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

/**
 * 利用者新規作成フック
 *
 * @param threeLetterCode - 企業コード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePostClientUser = (
  threeLetterCode: string,
  options?: {
    onSuccess?: (data: PostApiV1ThreeLetterCodeClientAdminsUsers201) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  const { trigger, isMutating } = useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsUsersMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsUsersMutationFetcher(threeLetterCode),
    options
  );

  return {
    trigger: trigger as (
      arg: PostApiV1ThreeLetterCodeClientAdminsUsersBody
    ) => Promise<PostApiV1ThreeLetterCodeClientAdminsUsers201>,
    isMutating,
  };
};
